"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Teams4;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Heading = _interopRequireDefault(require("./Heading2.js"));

var _CardProfileSkills = _interopRequireDefault(require("./CardProfileSkills.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
function Teams4(_ref) {
  var heading2 = _ref.heading2,
      cards = _ref.cards;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "py-20"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container mx-auto px-4"
  }, heading2 && /*#__PURE__*/_react.default.createElement(_Heading.default, heading2), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-wrap -mx-4 items-center"
  }, cards.map(function (prop, key) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: key,
      className: "mx-auto px-4 relative w-full md:w-5/12 lg:w-4/12"
    }, /*#__PURE__*/_react.default.createElement(_CardProfileSkills.default, prop));
  })))));
}

Teams4.defaultProps = {
  cards: [],
  heading2: null
};
Teams4.propTypes = {
  // prop to pass to the Heading2 component
  heading2: _propTypes.default.object,
  // an array of props that can be passed to the
  // CardProfileSkills component
  cards: _propTypes.default.arrayOf(_propTypes.default.object)
};
